import React from 'react'

/**
 * Generic segmented toggle. Renders a row of buttons inside a single bordered
 * container; the active option flips to the inverted-primary colour.
 *
 * Used for: type pickers, polarity toggles, mode switches.
 *
 * Props:
 *   - options: [{ value, label, disabled? }]
 *   - value:   currently selected value
 *   - onChange: (newValue) => void
 *   - ariaLabel: required for screen readers (the group label)
 */
export function SegmentedToggle({ options, value, onChange, ariaLabel, className = '', disabled = false }) {
  return (
    <div
      className={['segmented', className].filter(Boolean).join(' ')}
      role="group"
      aria-label={ariaLabel}
    >
      {options.map((opt) => {
        const active = opt.value === value
        return (
          <button
            key={opt.value}
            type="button"
            className="segmented__option"
            aria-pressed={active}
            disabled={disabled || opt.disabled}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
